import { useQuery } from "react-query";
import { getOnePlansRequest, getPlansPriceRequest } from "./request";


export const useFetchPlansOne = (idPlan) => {
    return useQuery(["UsePlansOne", idPlan], () => getOnePlansRequest(idPlan));
};

export const useFetchPlansPrice = (idPlan) => {
    return useQuery(["UsePlansPrice", idPlan], () => getPlansPriceRequest(idPlan));
};